import {fabric} from "fabric";
import {getLockValue, getSettingsDataInstance, removeObjectFromCanvas, unFocusObjects} from "@frontend/utils";
import {ADDITIONAL_LINE_PREFIX_ID} from "@frontend/constants/templates-field-prefixes";
import {FIELD_TYPE_LINE} from "@frontend/constants/type-fields-of-template";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
import {scaleControlsCornerSize} from "@frontend/constants/fabric-constants";
import {getGroupNameByAddFieldId} from "@/common/preview/draw-smart-object";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

const parseNumber = (value, fallback = 0) => {
  const number = Number.parseFloat(value);

  return Number.isFinite(number) ? number : fallback;
};

export function drawAdditionalLine({canvas, id,}) {
  unFocusObjects();

  removeObjectFromCanvas(canvas, ADDITIONAL_LINE_PREFIX_ID)

  const {canvas_data} = getScopePage();
  const settingsTemplate = getSettingsDataInstance(canvas_data[id]._data?.settings_template);

  canvas_data[id].additionalLines.forEach((elementId, index) => {
    const rawCoords = canvas_data[id]._data[`${elementId}_coords`];
    const coords = Array.isArray(rawCoords)
      ? rawCoords.map(coord => parseNumber(coord))
      : [0, 0, 0, 0];
    const x = parseNumber(canvas_data[id]._data[`${elementId}_offset_x`]);
    const y = parseNumber(canvas_data[id]._data[`${elementId}_offset_y`]);
    const order = canvas_data[id]._data[`${elementId}_order`];
    const opacity = parseFloat(canvas_data[id]._data[`${elementId}_opacity`]);
    const strokeWidth = parseNumber(canvas_data[id]._data[`${elementId}_thickness`], 1);
    const strokeColor = canvas_data[id]._data[`${elementId}_stroke_color`];
    const visible = canvas_data[id]._data[`${elementId}_visible`] ?? true;
    const objectId = ADDITIONAL_LINE_PREFIX_ID + index;

    const line = new fabric.Line(coords, {
      id: objectId,
      fieldType: FIELD_TYPE_LINE,
      element_id: elementId,
      order,
      fill: strokeColor,
      stroke: strokeColor,
      strokeUniform: true,
      strokeWidth: strokeWidth,
      selectable: true,
      evented: true,
      selectableBordersOnly: true,
      perPixelTargetFind: false,
      targetFindTolerance: 15,
      visible: visible,
      left: x,
      top: y,
      opacity: opacity,
      name: settingsTemplate.getNameById(objectId, 'Additional Line ' + (index + 1)),
      angle: parseNumber(canvas_data[id]._data[`${elementId}_angle`]),
      coords,
      groupName: getGroupNameByAddFieldId(
        objectId,
        canvas_data[id]
      )
    });

    line.containsPoint = function(point, lines, absolute, calculate) {
      const coords = this.calcLinePoints();
      const x1 = coords.x1, y1 = coords.y1, x2 = coords.x2, y2 = coords.y2;
      
      const localPoint = fabric.util.transformPoint(point, fabric.util.invertTransform(this.calcTransformMatrix()));
      
      const A = localPoint.x - x1;
      const B = localPoint.y - y1;
      const C = x2 - x1;
      const D = y2 - y1;
      
      const dot = A * C + B * D;
      const lenSq = C * C + D * D;
      let param = -1;
      
      if (lenSq !== 0) {
        param = dot / lenSq;
      }
      
      let xx, yy;
      
      if (param < 0) {
        xx = x1;
        yy = y1;
      } else if (param > 1) {
        xx = x2;
        yy = y2;
      } else {
        xx = x1 + param * C;
        yy = y1 + param * D;
      }
      
      const dx = localPoint.x - xx;
      const dy = localPoint.y - yy;
      const distance = Math.sqrt(dx * dx + dy * dy);
      
      const selectionTolerance = Math.max(this.strokeWidth / 2, 8) + 12;
      
      return distance <= selectionTolerance;
    };

    scaleControlsCornerSize(line);

    canvas.add(line);
    line.bringToFront();
  });
}
